import React, { lazy, Suspense, useContext } from "react";

//Components
import AppShell from "components/shared/AppShell";
import PageLoading from "components/shared/Icon/PageLoading";

//contexts
import { UserContext } from "state/user/userContext";

//Pages
import Login from "container/Authentication/Login";
import Register from "container/Authentication/Register";
import OTP from "container/Authentication/OTP";
import ForgetPassword from "container/Authentication/ForgetPassword";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

//Pages
const Test = lazy(() => import("container/Test"));
const Dashboard = lazy(() => import("container/Dashboard"));
const Payments = lazy(() => import("container/Payments"));
const Notification = lazy(() => import("container/Notification"));
const ProfileSettings = lazy(() => import("container/ProfileSettings"));
const CompleteRegister = lazy(() => import("container/CompleteRegister"));
const Ticket = lazy(() => import("container/Ticket"));
const Invoice = lazy(() => import("container/Invoice"));
const Link = lazy(() => import("container/Link"));

const FileStore = lazy(() => import("container/FileStore"));

const PersonalPage = lazy(() => import("container/PersonalPage"));

const PaymentForm = lazy(() => import("container/Menu/PaymentForm"));
const NewPaymentForm = lazy(() => import("container/Menu/PaymentForm/NewPaymentForm"));
const PaymentFormLists = lazy(() => import("container/Menu/PaymentForm/PaymentFormLists"));

const Financial = lazy(() => import("container/Menu/Financial"));

const NewGateway = lazy(() => import("container/Gateways/New/index"));
const GatewayList = lazy(() => import("container/Gateways/GatewayList"));
const TerminalList = lazy(() =>
  import("container/Gateways/Terminal/TerminalList")
);
const NewTerminal = lazy(() =>
  import("container/Gateways/Terminal/NewTerminal")
);
const SearchPayments = lazy(() => import("container/Gateways/search/index.js"));
const AccountsBankTerminal = lazy(() =>
  import("container/Gateways/Terminal/AccountsBankTerminal")
);
const NewAccountBankTerminal = lazy(() =>
  import("container/Gateways/Terminal/NewAccountBankTerminal")
);
const GatewayDashboard = lazy(() =>
  import("container/Gateways/GatewayDashboard")
);

const GatewayReport = lazy(() => import("container/Gateways/Report"));

const Settings = lazy(() => import("container/Gateways/Settings"));
const NotificationSettings = lazy(() =>
  import("container/Gateways/Settings/NotificationSettings")
);
const IPSettings = lazy(() => import("container/Gateways/Settings/IPSettings"));

const NewIp = lazy(() => import("container/Gateways/Settings/NewIp"));

const GatewayEdit = lazy(() => import("container/Gateways/GatewayEdit"));
const SettlementsList = lazy(() => import("container/Gateways/Settlement"));
const SettlementDetail = lazy(() =>
  import("container/Gateways/Settlement/Detail")
);

const SettlementRequestableList = lazy(() =>
  import("container/Gateways/Settlement/RequestableList")
);

const SettlementRequestDetail = lazy(() =>
  import("container/Gateways/Settlement/SettlementRequestDetail")
);

const Report = lazy(() => import("container/Report"));
const ReportDetail = lazy(() => import("container/Report/Detail"));

const LoadingFallback = () => (
  <AppShell>
    <PageLoading />
  </AppShell>
);

export const AuthRoutes = ({ children, ...rest }) => {
  const { token } = useContext(UserContext);
  return (
    <Route
      {...rest}
      render={() => (!token ? <>{children}</> : <Redirect to="/dashboard" />)}
    ></Route>
  );
};

const HomePageRoutes = ({ children }) => {
  const { state } = useContext(UserContext);

  return (
    <Route
      path="/"
      render={() => (state.token ? <AppShell>{children}</AppShell> : <Login />)}
    ></Route>
  );
};

const AuthenticatedRoute = ({ children, ...rest }) => {
  //Use Context
  const { state } = useContext(UserContext);

  return (
    <Route
      {...rest}
      render={() =>
        state.token ? <AppShell>{children}</AppShell> : <Redirect to="/login" />
      }
    ></Route>
  );
};

const AppRoutes = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Switch>
      <AuthenticatedRoute path="/test">
          <Test />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/dashboard">
          <Dashboard />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/payments">
          <Payments />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/invoice">
          <Invoice />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/product">
          <Invoice />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/customer">
          <Invoice />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/Link">
          <Link />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/file-store">
          <FileStore />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/personal-page">
          <PersonalPage />
        </AuthenticatedRoute>
        
       
        <AuthenticatedRoute path={["/notification", "/notificationdetail/:id"]}>
          <Notification />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/profile-settings">
          <ProfileSettings />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/complete-register">
          <CompleteRegister />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/gateway/new">
          <NewGateway />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/gateway/list">
          <GatewayList />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/gateway/:gatewayId/edit">
          <GatewayEdit />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/gateway/:gatewayId/dashboard">
          <GatewayDashboard />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/gateway/:gatewayId/terminal">
          <TerminalList />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/gateway/:gatewayId/new-terminal">
          <NewTerminal />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/financial">
          <Financial />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/payments-form">
          <PaymentForm />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/new-payments-form/">
          <NewPaymentForm />
        </AuthenticatedRoute>
        <AuthenticatedRoute path={["/edit-payments-form/:id", "/edit-payments-form/:id"]}>
          <NewPaymentForm />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/payments-form/list">
          <PaymentFormLists />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/terminal/:terminalId/bank-accounts">
          <AccountsBankTerminal />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/terminal/:terminalId/new-account">
          <NewAccountBankTerminal />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/gateway/:gatewayId/search">
          <SearchPayments />
        </AuthenticatedRoute>
        <AuthenticatedRoute path={"/gateway/:gatewayId/report/:reportType"}>
          <GatewayReport />
        </AuthenticatedRoute>

        <AuthenticatedRoute path={"/gateway/:gatewayId/settings"}>
          <Settings />
        </AuthenticatedRoute>
        <AuthenticatedRoute path={"/gateway/:gatewayId/ip"}>
          <IPSettings />
        </AuthenticatedRoute>
        <AuthenticatedRoute path={"/gateway/:gatewayId/new-ip"}>
          <NewIp />
        </AuthenticatedRoute>
        <AuthenticatedRoute path={"/gateway/:gatewayId/notification-settings"}>
          <NotificationSettings />
        </AuthenticatedRoute>

        <AuthenticatedRoute path={"/gateway/:gatewayId/settlement"}>
          <SettlementsList />
        </AuthenticatedRoute>

        <AuthenticatedRoute
          path={"/gateway/:gatewayId/settlement-detail/:settlementId"}
        >
          <SettlementDetail />
        </AuthenticatedRoute>

        <AuthenticatedRoute path={"/gateway/:gatewayId/settlement-list"}>
          <SettlementRequestableList />
        </AuthenticatedRoute>

        <AuthenticatedRoute
          path={"/gateway/:gatewayId/settlementrequest-detail/:terminalId"}
        >
          <SettlementRequestDetail />
        </AuthenticatedRoute>

        <AuthenticatedRoute
          path={["/ticket", "/new-ticket", "/ticketdetail/:id"]}
        >
          <Ticket />
        </AuthenticatedRoute>
        <AuthenticatedRoute path={"/report"}>
          <Report />
        </AuthenticatedRoute>

        <AuthenticatedRoute path={"/payment/:paymentId"}>
          <ReportDetail />
        </AuthenticatedRoute>

        <AuthRoutes path="/login">
          <Login />
        </AuthRoutes>
        <AuthRoutes path="/register">
          <Register />
        </AuthRoutes>
        <AuthRoutes path="/forgetpassword">
          <ForgetPassword />
        </AuthRoutes>
        <AuthRoutes path="/otp">
          <OTP />
        </AuthRoutes>
        <HomePageRoutes>
          <Dashboard />
        </HomePageRoutes>
      </Switch>
    </Suspense>
  );
};

export default AppRoutes;
